/**
 * Sanitizes URLs by removing invisible Unicode characters that can cause issues
 * @param {string} url - The URL to sanitize
 * @returns {string} - The sanitized URL
 */
export const sanitizeUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return url
  }

  const invisibleChars = /[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g
  try {
    const decodedUrl = decodeURIComponent(url)
    const sanitized = decodedUrl.replace(invisibleChars, '').trim()

    if (sanitized !== decodedUrl) {
      return sanitized
    }
    return url
  } catch (error) {
    return url.replace(invisibleChars, '').trim()
  }
}
